import { call, put, takeLatest } from "redux-saga/effects";

import { ManagerHashtagReportAction } from "../../actions";

import * as types from "../../actions/actionTypes";

import moment from "jalali-moment";
import * as hashtagReportApi from "../../api/hashtagReport/managerHashtagReport";
import { toastr } from "react-redux-toastr";
import checkErrorMessagesExist from "../../assets/checkErrorMessagesExist";
import { GetFilter } from "../../hocs/hashtagsReport/components/filter/tools";
import { HASHTAGS_REVIEW_MANAGER } from "../../constants/urls";
import {
  defaultNormalizerWithSeparateMetaObj,
  fetchAllPages
} from "../../assets/fetchAllPageTogether";
import { SetMessage } from "../../assets/errorMessages";

moment.locale("fa");
export function* managerWatcherHashtagReport() {
  yield takeLatest(types.MANAGER_GET_HASHTAG_SUMMARY_REQUEST, worker);
  yield takeLatest(types.MANAGER_GET_ALL_HASHTAG_USED_REQUEST, workerAllUsed);
}

async function fetchList(pageNumber = null) {
  const page_number = pageNumber ? pageNumber : "";

  return hashtagReportApi.getSummaryList(page_number, GetFilter());
}

function* worker(action) {
  try {
    const response = yield call(fetchList, action.pageNumber);
    yield put(ManagerHashtagReportAction.getSummarySuccess(response.data));
  } catch (error) {
    // dispatch a failure action to the store with the error
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });

    yield put(ManagerHashtagReportAction.getSummaryFailure(error));
  }
}

function getRequest(pageNumber, finalFilter) {
  return hashtagReportApi.getAllList(pageNumber, finalFilter);
}

function* workerAllUsed() {
  try {
    const response = yield fetchAllPages(
      getRequest,
      null,
      defaultNormalizerWithSeparateMetaObj,
      null,
      document.location.pathname === HASHTAGS_REVIEW_MANAGER
    );
    yield put(ManagerHashtagReportAction.getAllUsedSuccess(response.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(ManagerHashtagReportAction.getAllUsedFailure(message));
  }
}
